import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("TemplateOutput")
export class TemplateOutput {
    @JsonProperty()
    public id: string = "";

    @JsonProperty()
    public title: string = "";

    @JsonProperty()
    public note: string = "";

    @JsonProperty()
    public createdUserName: string = "";

    @JsonProperty()
    public createdAt: string = "";

    @JsonProperty()
    public deleted: boolean = false;
}

@JsonObject("TemplateListOutput")
export class TemplateListOutput {
    // 配列はデフォルトで JsonPropertyEmpty を使って初期化
    @JsonProperty()
    public templates?: TemplateOutput[] = JsonPropertyEmpty;

    @JsonProperty()
    public previousPageExists: boolean = false;

    @JsonProperty()
    public nextPageExists: boolean = false;

    @JsonProperty()
    public totalCount: number = 0;
}
